// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"236":"018e5b3c","522":"f7dcb048","573":"be99d8e0"}[chunkId] + ".js";
};